import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";
import { Select } from "@mui/material";
import { isMobile } from "react-device-detect";
import { getMonthAbbreviation } from "../services/dateService";
import { MenuItem } from "@material-ui/core";
import { getUserPid } from "../services/userService";
import _ from "lodash";

export const QuestionnaireQuestionWithMonthYearPage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [selectedOption, setSelectedOption] = useState("");
	const [defaultOption, setDefaultOption] = useState("");
	const [optionDef, setOptionDef] = useState({});
	const [month, setMonth] = useState("");
	const [year, setYear] = useState("");
	const [enableDate, setEnableDate] = useState(false);
	const [menuOptions, setMenuOptions] = useState([]);
	const [invalidDate, setInvalidDate] = useState(false);
	const [invalidDateMessage, setInvalidDateMessage] = useState(false);
	const [dob, setDob] = useState(null);

	useEffect(() => {
		const userPid = getUserPid();
		setDob(new Date(userPid.dob));
	}, []);

	const checkError = (params) => {
		const { option, month, year } = { ...params };

		if (!def.dateIsMandatory) {
			return false;
		}

		// find the option from the def
		let opt = {};
		for (const o in def.options) {
			if (o.value === option) {
				opt = o;
				break;
			}
		}

		if (!opt.enableDate) {
			return false;
		}

		if (month && year) {
			return false;
		} else {
			return true;
		}
	};

	const isDateInvalid = (month, year) => {
		const sDate = new Date(year, month, 1);

		if (sDate < dob) {
			setInvalidDateMessage("The date cannot be before your date of birth");
			return true;
		}

		if (sDate > new Date()) {
			setInvalidDateMessage("The date cannot be in the future");
			return true;
		}

		return false;
	};

	const onSetMonth = (e) => {
		let val = e.target.value;
		let check = false;
		setMonth(val);

		if (year) {
			check = isDateInvalid(val, year);
			setInvalidDate(check);
		}

		let error =
			check || checkError({ option: selectedOption, month: val, year });

		const response = {};
		response.id = def.id;
		response.value = {
			option: selectedOption,
			month: val,
			year,
			error,
		};

		onRespond(response);
	};

	const onSetYear = (e) => {
		let val = e.target.value;
		let check = false;
		setYear(val);

		if (month) {
			check = isDateInvalid(month, val);
			setInvalidDate(check);
		}

		let error =
			check || checkError({ option: selectedOption, month: val, year });

		const response = {};
		response.id = def.id;
		response.value = { option: selectedOption, month, year: val, error };

		onRespond(response);
	};

	useEffect(() => {
		const dob = new Date(getUserPid().dob);
		let minYear = dob.getFullYear();

		const months = [];
		const years = [];

		if (isMobile) {
			months.push(
				<option value="-1" disabled>
					Please Select
				</option>
			);
			years.push(
				<option value="-1" disabled>
					Please Select
				</option>
			);
		} else {
			months.push(
				<MenuItem value="-1" disabled>
					Please Select
				</MenuItem>
			);
			years.push(
				<MenuItem value="-1" disabled>
					Please Select
				</MenuItem>
			);
		}
		const mappedMonths = _.range(12).map((e) => {
			if (isMobile === true) {
				return <option value={e}>{getMonthAbbreviation(e)}</option>;
			}

			return <MenuItem value={e}>{getMonthAbbreviation(e)}</MenuItem>;
		});

		months.push(...mappedMonths);

		const mappedYears = _.range(minYear, new Date().getFullYear() + 1).map(
			(e) => {
				if (isMobile === true) {
					return <option value={e}>{e}</option>;
				}

				return <MenuItem value={e}>{e}</MenuItem>;
			}
		);

		years.push(...mappedYears);

		setMenuOptions({
			months: months,
			years: years,
		});
	}, []);

	useEffect(() => {
		let opt = "";
		let month = "";
		let year = "";

		const now = new Date();
		now.setMonth(now.getMonth() - 1);
		const defMonth = now.getMonth();
		const defYear = now.getFullYear();

		if (def.options) {
			for (const o of def.options) {
				if (o.default) {
					setOptionDef(o);
					setEnableDate(o.enableDate);

					opt = o.value;
					month = o.month || defMonth || "";
					year = o.year || defYear || "";
					break;
				}
			}
		}

		setDefaultOption(opt);
		setMonth(month);
		setYear(year);

		if (!currentResponse) {
			const error = checkError({ option: opt, month, year });
			const response = {};
			response.id = def.id;
			response.value = { option: opt, month, year, error };

			onRespond(response);
		}
	}, [def]);

	useEffect(() => {
		let opt;
		let month;
		let year;

		if (currentResponse && currentResponse.value) {
			opt = currentResponse.value.option;
			month = currentResponse.value.month;
			year = currentResponse.value.year;
		} else if (def.answer) {
			opt = def.answer.option;
			month = def.answer.month;
			year = def.answer.year;
			handleOptionChange({ target: { value: def.answer, checked: true } });
		} else {
			opt = optionDef?.option || "";
			month = optionDef?.month;
			year = optionDef?.year;
		}

		let _odef = {};
		for (const o of def.options) {
			if (o.value.toString() === opt.toString()) {
				_odef = o;
				break;
			}
		}

		const now = new Date();
		now.setMonth(now.getMonth() - 1);
		const defMonth = now.getMonth();
		const defYear = now.getFullYear();

		setOptionDef(_odef);
		if (_odef.enableDate) {
			setMonth(month == null || month === "" ? defMonth : month);
			setYear(year == null || year === "" ? defYear : year);
			setEnableDate(true);

			const check = isDateInvalid(
				month == null || month === "" ? defMonth : month,
				year == null || year === "" ? defYear : year
			);
			setInvalidDate(check);
		} else {
			setMonth("");
			setYear("");
			setEnableDate(false);
		}

		setSelectedOption(opt);
	}, [currentResponse, defaultOption, def]);

	const handleOptionChange = (e) => {
		let value = e.target.value;
		const checked = e.target.checked;

		if (!checked) {
			value = defaultOption;
		}
		setSelectedOption(value);

		let _odef = {};
		for (const o of def.options) {
			if (o.value.toString() === value.toString()) {
				_odef = o;
				break;
			}
		}

		const now = new Date();
		now.setMonth(now.getMonth() - 1);
		const defMonth = now.getMonth();
		const defYear = now.getFullYear();

		setOptionDef(_odef);
		let _month = "";
		let _year = "";
		let _enableDate = false;
		if (_odef.enableDate) {
			_month = month == null || month === "" ? defMonth : month;
			_year = year == null || year === "" ? defYear : year;
			_enableDate = true;
		}

		setMonth(_month);
		setYear(_year);
		setEnableDate(_enableDate);

		const response = {};
		const error = checkError({ option: value, _month, _year });
		response.id = def.id;
		response.value = { option: value, _month, _year, error };

		onRespond(response);
	};

	const renderOptions = (s) => {
		return def.options
			? def.options.map((option, i) => (
					<div key={`${i}_container`} className={option.hidden ? "hidden" : ""}>
						<label
							key={`${i}_label`}
							className={`${
								s === option.value.toString()
									? `bg-black text-white font-medium`
									: "bg-gray-100 text-black"
							} text-right text-base sm:text-lg leading-5 sm:leading-6 font-normal rounded-full mx-3 option pr-2 pl-7 py-2.5 cursor-pointer flex items-center justify-end my-3 lg:my-4`}
						>
							{option.label}
							<span
								className={`flex flex-0-0-auto justify-center items-center w-4 h-4 text-white border border-gray-400 rounded mx-2.5`}
							>
								{s === option.value.toString() && <FaCheck size={8} />}
							</span>
							<input
								key={`${i}_input`}
								name={def.title}
								value={option.value.toString()}
								className={"hidden "}
								type={def.forceSelect ? "radio" : "checkbox"}
								checked={s === option.value.toString()}
								onChange={handleOptionChange}
							/>
						</label>
					</div>
			  ))
			: null;
	};

	return (
		<>
			<QuestionnaireHeader def={def} />

			<div>{renderOptions(selectedOption)}</div>

			{def.dateHeader && (
				<h3
					className={`font-bold mt-6 ${
						enableDate ? "text-black" : "text-gray-400"
					}`}
				>
					{def.dateHeader}
				</h3>
			)}

			<div className={`formInputContainer ${def.dateHeader ? "" : "mt-6"}`}>
				<div className={"flex pt-2 pb-2"}>
					<div className={"w-1/2 flex flex-col pr-2"}>
						<label
							className={`basicFormLabel ${
								enableDate ? "text-black" : "text-gray-400"
							}`}
							htmlFor={"month"}
						>
							Month
						</label>
						<Select
							id="month"
							native={isMobile}
							value={month.toString()}
							className={`bg-white text-sm h-9 ${
								invalidDate ? "text-red-800" : null
							}`}
							onChange={onSetMonth}
							displayEmpty={true}
							disabled={!enableDate}
						>
							{menuOptions.months}
						</Select>
					</div>

					<div className={"w-1/2 flex flex-col pl-2"}>
						<label
							className={`basicFormLabel ${
								enableDate ? "text-black" : "text-gray-400"
							}`}
							htmlFor={"year"}
						>
							Year
						</label>
						<Select
							native={isMobile}
							id="year"
							value={year.toString()}
							className={`bg-white text-sm h-9 ${
								invalidDate ? "text-red-800" : null
							}`}
							onChange={onSetYear}
							displayEmpty={true}
							disabled={!enableDate}
						>
							{menuOptions.years}
						</Select>
					</div>
				</div>
				{invalidDate ? (
					<div
						className={"text-center text-red-800 rounded-sm pseudoBeforeHidden"}
					>
						{invalidDateMessage}
					</div>
				) : null}
			</div>

			<QuestionnaireFooter def={def} />
		</>
	);
};
